<template>
    <el-dialog :show-close="false" :visible.sync="dialogVisible" width="400px">
        <div class="content">
            <img class="activity-pic" :src="checkActivityData.pic" @click="handleCLickActivity"/>
            <div class="icon-close">
                <i class="el-icon-circle-close" @click="dialogVisible = false"></i>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'CheckActivityDlg',
    data() {
        return {
            // 活动列表
            dialogVisible: false,
            checkActivityData: {
                pic: '',
                path: ''
            }
        };
    },
    methods: {
        publicOpen(e) {
            this.dialogVisible = true;
            this.checkActivityData = { ...e };
        },
        // 点击活动图片
        handleCLickActivity() {
            const list_1 = this.checkActivityData.path.split('?')
            if(list_1.length >= 2) {
                const list_2 = list_1[1].split('=')
                if(list_2.length >= 2) {
                    const activityId = list_2[1]
                    this.dialogVisible = false;
                    this.$router.push({
                        path: "/checkActivity",
                        query: {
                            activityId: activityId
                        }
                    })
                }
            }
        }
    }
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
    background-color: transparent;
    --webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
::v-deep .el-dialog__body {
    padding: 0;
    background-color: transparent;
}

::v-deep .el-dialog__header {
    display: none;
}
.content {
    border-radius: 40px;
    background-color: transparent;
    overflow: hidden;
    .activity-pic {
        width: 400px;
    }
    .icon-close {
        height: 50px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        transform: translateY(100%);
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        color: #fff;
    }
}
</style>
